module.exports = __webpack_public_path__ + "static/media/3t-white.2a7cce35.png";